import { render, staticRenderFns } from "./PqSubscription.vue?vue&type=template&id=ef2c169c&"
import script from "./PqSubscription.vue?vue&type=script&lang=js&"
export * from "./PqSubscription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports